module.exports = __webpack_public_path__ + "img/browse-vehicles-search-hero-toyota-02.f2b0ed04.png";